// eslint-disable-next-line import/prefer-default-export
export const getBaseUrl = (): string => {
    const url = new URL(window.location.href);
    if (url.origin.endsWith("demo.adadot.com")) return "https://sit.adadot.com";
    return url.origin;
};

// eslint-disable-next-line import/prefer-default-export
export const getBaseWsUrl = (): string => {
    const url = new URL(window.location.href);
    if (url.origin.endsWith("demo.adadot.com")) return "https://sit.adadot.com";
    return url.origin.replace("https", "wss");
};

export const getAssetsUrl = (): string => {
    const isProd = process.env.ENVIRONMENT_NAME === "prod";
    if (!isProd) return "https://assets-sit.adadot.com";
    return "https://assets.adadot.com";
};
